function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';
import { Translate } from "../../I18N";
import { useForm } from 'react-hook-form';
import Modal from "../../Layout/Modal";













const createSelectValues = (values) => {
  const selectOptions = [{ value: 'root', label: '<root>' }];
  if (!values) return selectOptions;
  values.
  filter((value) => value.values).
  forEach((value) => selectOptions.push({ value: value.id, label: value.label }));
  return selectOptions;
};

const AddThesauriValueModal = ({
  isOpen,
  values,
  onAccept,
  onCancel
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    reset
  } = useForm({ defaultValues: { group: 'root' } });

  const onSubmitted = (submittedValues) => {
    onAccept(submittedValues);
  };

  const renderGroupSelect = (selectValues) => /*#__PURE__*/
  React.createElement(React.Fragment, null, /*#__PURE__*/
  _jsx("label", { className: "form-label", htmlFor: "group" }, void 0, /*#__PURE__*/
  _jsx(Translate, {}, void 0, "Group")
  ), /*#__PURE__*/
  React.createElement("select", _extends({},
  register('group'), {
    className: "form-control thesauri-group",
    defaultValue: "root",
    id: "group" }),

  selectValues.map((option) => /*#__PURE__*/
  _jsx("option", { value: option.value }, option.value,
  option.label
  )
  )
  )
  );


  const validateDuplicates = (newValue) => {
    let innerValues = values;
    if (newValue.group !== 'root') {var _values$find;
      innerValues = ((_values$find = values.find((value) => value.id === newValue.group)) === null || _values$find === void 0 ? void 0 : _values$find.values) || [];
    }
    const index = innerValues.findIndex((value) => value.label === newValue.value);
    return index === -1;
  };

  const selectValues = createSelectValues(values);

  return /*#__PURE__*/(
    _jsx(Modal, { isOpen: isOpen, type: "info", className: "add-thesauriValue-modal" }, void 0, /*#__PURE__*/
    _jsx("form", {
      onSubmit: async (e) => {
        e.preventDefault();
        e.stopPropagation();
        await handleSubmit(onSubmitted)(e);
      },
      className: "file-form" }, void 0, /*#__PURE__*/

    _jsx(Modal.Header, {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Add thesaurus value")
    ), /*#__PURE__*/
    _jsx(Modal.Body, {}, void 0,
    errors.value && /*#__PURE__*/
    _jsx("p", { className: "error", role: "alert" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Duplicate values not allowed.")
    ),

    selectValues.length > 1 && renderGroupSelect(selectValues), /*#__PURE__*/
    _jsx("label", { htmlFor: "newThesauriValue" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Value")
    ), /*#__PURE__*/
    React.createElement("input", _extends({},
    register('value', {
      required: true,
      validate: () => validateDuplicates(getValues())
    }), {
      className: "form-control",
      placeholder: "value",
      id: "newThesauriValue" })
    )
    ), /*#__PURE__*/

    _jsx(Modal.Footer, {}, void 0, /*#__PURE__*/
    _jsx("button", {
      type: "button",
      className: "btn cancel-button",
      onClick: () => {
        reset({ group: 'root', value: '' });
        onCancel();
      } }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Cancel")
    ), /*#__PURE__*/
    _jsx("button", { type: "submit", className: "btn btn-success confirm-button" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Save")
    )
    )
    )
    ));

};

export default AddThesauriValueModal;